import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';

export function createDeleteModelResponse() : ParameterType
{
    const desc = (<>
        <p>Response returned when a model is successfully deleted. Contains the model identifier and a confirmation message.</p>
        </>);

    return {
        id          : "DeleteModelResponse",
        name        : "DeleteModelResponse",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "id",
                "type"        : "string",
                "description" : <p>The identifier of the deleted model.</p>,
                "optional"    : false
            },
            {
                "name"        : "message",
                "type"        : "string",
                "description" : <p>Confirmation message indicating that the model has been deleted.</p>,
                "optional"    : false
            }
        ]
    };
}

